module.exports = __webpack_public_path__ + "static/img/1-7.0952605.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/1-7.png
// module id = Zamr
// module chunks = 15